module.exports = __webpack_public_path__ + "static/dockington-reports-bar-graph-e49f3cb859326451f4471ff971cbff34.jpg";